import { type GenericObject } from "@taager/reinforcements";
import { mixpanelService } from "./mixpanel";

export function mixPanelEvent(eventName: string, data?: GenericObject): void {
  mixpanelService.track(eventName, data);
}

export { mixpanelService };
